@if (refLink.type === RefLinkType.EXTERNAL_LINK_TYPE) {
  <a [routerLink]="['/external', refLink.url]" target="_blank" rel="noopener noreferrer"
    [matTooltip]="refLink.url || ''" matTooltipPosition="below" ngClass="link-external"
  (click)="$event.stopPropagation()">{{ text }}</a>
}
@if (refLink.type !== RefLinkType.EXTERNAL_LINK_TYPE) {
  <pub-internal-link-render [refLink]="refLink" [text]="text" (conceptSelected)="selectConcept($event)">
  </pub-internal-link-render>
}
